import { SettlementType } from 'app/constants/settlementType'

export const getSettlementTypeName = (
  type: SettlementType,
  translate: (string) => string,
): string => {
  let text = '-'

  switch (type) {
    case SettlementType.Month:
      text = 'settlementType.month'
      break
    case SettlementType.Hour:
      text = 'settlementType.hour'
      break
    case SettlementType.ForContract:
      text = 'settlementType.forContract'
      break
  }

  return text != '-' ? translate(text) : text
}
